import React, { useEffect } from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';
import SelectComponent from '../Inputs/SelectComponent';
import CustomInput from '../Inputs/CustomInput';

function NewBatchModal(props) {
  const { theme } = useTheme();

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleNoBatch = () => {
    props.setBatchName("none");
    handleClose();
  };

  const handleSave = () => {
    props.handleNext();
    handleClose();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSave();
    }
  };

  const handleChangeChannel = (c) => {
    props.setChannel(c);
  }

  useEffect(() => {
    if (props.batchName === "none" && props.open === false) {
      props.handleNext();
    }
  }, [props.batchName, props.open]);

  const styles = {
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '26vw',
      bgcolor: theme.background.primary,
      borderRadius: 2,
      border: `4px solid ${theme.color.primary}`,
      boxShadow: 24,
      p: 4,
      outline: 'none',
    },
    button: {
      textTransform: 'none',
      fontFamily: theme.fontFamily,
      color: theme.text.negative,
      borderRadius: '20px',
      border: `1px solid ${theme.border.light}`
    }
  }

  return (
    <>
      <Modal open={props.open} onClose={handleClose}>
        <Box sx={styles.modal}>
          <Typography variant="h6" component="h2" gutterBottom style={{ fontFamily: theme.fontFamily, textAlign: 'center', color: theme.text.primary }}>
            New Batch
          </Typography>

          {/* Form */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2, justifyContent: 'space-around', }} onKeyDown={handleKeyDown}>
            <CustomInput
              fullWidth
              label={"Batch Name"}
              value={props.batchName}
              onChange={(e) => props.setBatchName(e.target.value)}
              type="text"
              autoFocus
            />

            <SelectComponent
              value={props.channel}
              title={"Channel"}
              onChange={handleChangeChannel}
              options={[
                { value: "wfs", name: "WFS" },
                { value: "sf", name: "SF" }
              ]}
              width={"fullWidth"}
            />

            <Button variant="contained" onClick={handleNoBatch} sx={{...styles.button, backgroundColor: theme.accent.success, }} >
              No Batch
            </Button>
          </Box>

          {/* Cancel and Save buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 3 }}>
            <Button variant="contained" onClick={handleClose} sx={{...styles.button, backgroundColor: theme.accent.error, }} >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave} sx={{...styles.button, backgroundColor: theme.accent.success, }} >
              Create
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default NewBatchModal;
